/* shto-scp-pdp-reviews: the progress bar under the review row follows its scroll (0 at the start, 1 at the end), and the
   row moves one card per arrow key (Home / End: first / last) when it has keyboard focus. Dragging and swiping are
   assets/shto-swipe.js. Nothing moves by itself. */
(function () {
  if (window.ShtoScpPdpReviews) return;
  window.ShtoScpPdpReviews = true;

  function init(root) {
    var row = root.querySelector('.shto-scp-pdp-reviews-row');
    var track = root.querySelector('.shto-scp-pdp-reviews-progress');
    if (!row || row.shtoReviews) return;
    row.shtoReviews = true;
    var ticking = false;

    function max() { return Math.max(0, row.scrollWidth - row.clientWidth); }
    function update() {
      ticking = false;
      var m = max();
      if (m < 1) root.setAttribute('data-shto-still', ''); else root.removeAttribute('data-shto-still');
      if (track) track.style.setProperty('--at', m < 1 ? 0 : Math.min(1, Math.max(0, row.scrollLeft / m)).toFixed(4));
    }
    function ask() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    row.addEventListener('scroll', ask, { passive: true });
    window.addEventListener('resize', ask);
    update();

    function stops() {
      var cards = Array.prototype.filter.call(row.children, function (c) { return c.offsetWidth > 0; });
      var base = cards.length ? cards[0].offsetLeft : 0, m = max();
      var out = cards.map(function (c) { return Math.min(m, Math.max(0, c.offsetLeft - base)); });
      out.push(m);
      return out.filter(function (v, i, a) { return a.indexOf(v) === i; }).sort(function (a, b) { return a - b; });
    }
    row.addEventListener('keydown', function (e) {
      if (e.target !== row) return;
      var s = stops(), here = row.scrollLeft, to = null, i;
      if (e.key === 'ArrowRight') { for (i = 0; i < s.length; i++) if (s[i] > here + 1) { to = s[i]; break; } }
      else if (e.key === 'ArrowLeft') { for (i = s.length - 1; i >= 0; i--) if (s[i] < here - 1) { to = s[i]; break; } }
      else if (e.key === 'Home') to = 0;
      else if (e.key === 'End') to = max();
      else return;
      e.preventDefault();
      if (to === null) return;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      row.scrollTo({ left: to, behavior: reduce ? 'auto' : 'smooth' });
    });
  }

  function initAll(scope) { (scope || document).querySelectorAll('.shto-scp-pdp-reviews').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
